/* eslint import/prefer-default-export: 0 */

import * as t from './action_types';

/**
 * {
 *   style_guide - enable view for using new style guide,
 * }
 */

const initialState = false;

export default (state = initialState, action) => {
  switch (action.type) {
    case t.STYLE_GUIDE_UPDATE:
      return action.payload;
    default:
      return state;
  }
};
